// Import hooks.
import {
	useInputForm,
	UseInputFormResult,
} from '@app/hooks/view/input';
// Import enumerations.
import {
	BroadLineOfBusiness
} from '@app/enumerations';
// Import app models.
import {
	ValidatorResponse,
} from '@app/models/app';
// Import api models.
import {
	PerilDeductible,
	PossiblePeril,
} from '@app/models/api';
// Import props.
import {
	InputFormProps,
	InputPerilsSelectionListProps,
} from '@app/props';

interface UseInputPerilsSelectionListParameters {
	id: string;
	label: string;
	required: boolean;
	disabled: boolean;
	selectedPerils: PerilDeductible[];
	possiblePerils: PossiblePeril[];
	broadLineOfBusinessCode: BroadLineOfBusiness;
	showValidation?: boolean;
}

type UseInputPerilsSelectionListResults = UseInputFormResult<PerilDeductible[], InputPerilsSelectionListProps>

const useInputPerilsSelectionList = (params: UseInputPerilsSelectionListParameters): UseInputPerilsSelectionListResults => {

	// #region exported methods

	/**
	 * Returns props for perils selection list input. 
	 **/
	const applyInputPerilsSelectionListProps = (): InputPerilsSelectionListProps => {
		// First apply the form input props.
		let formProps: InputFormProps = applyProps();
		// Then apply the perils selection list props.
		return {
			...formProps,
			broadLineOfBusinessCode: params.broadLineOfBusinessCode,
			selectedPerils: other.value,
			possiblePerils: params.possiblePerils,
			onSelectPeril: other.setInput,
		}
	};

	// #endregion exported methods


	// #region private methods

	/**
	 * Validates the selected perils.
	 * @param state
	 */
	const validatePerils = (selectedPerils: PerilDeductible[], required: boolean): ValidatorResponse => {
		if (required
			&& selectedPerils.length < 1) {
			return new ValidatorResponse(false, 'Please select one or more of the following peril options.');
		}

		return new ValidatorResponse(true, String.empty());
	}

	// #endregion private methods


	// #region variables

	// Instantiate the 'address' input.
	const { applyProps, ...other } = useInputForm<PerilDeductible[]>({
		id: params.id,
		label: params.label,
		required: params.required,
		disabled: params.disabled,
		initialInput: params.selectedPerils,
		showValidation: params.showValidation,
		validators: [validatePerils],
	});

	// #endregion variables


	return {
		applyProps: applyInputPerilsSelectionListProps,
		...other,
	};
}

// Export parameters.
export {
	UseInputPerilsSelectionListParameters,
}

// Export results.
export {
	UseInputPerilsSelectionListResults,
}

export default useInputPerilsSelectionList;